import React from 'react';

import { useFormikContext } from 'formik';

import LessonGoals from './LessonGoals';

const LessonGoalsContainer = () => {
  const { values, setFieldValue } = useFormikContext();

  const handleAddGoalClick = () => {
    setFieldValue('goals', [...values.goals, '']);
  };

  const handleRemoveGoalClick = (goalIndex) => {
    setFieldValue(
      'goals',
      values.goals.filter((_, index) => goalIndex !== index),
    );
  };

  return (
    <LessonGoals
      goals={values.goals}
      onAddGoalClick={handleAddGoalClick}
      onRemoveGoalClick={handleRemoveGoalClick}
    />
  );
};

export default React.memo(LessonGoalsContainer);
